export const dateMask = 'M0/d0/0000';
